// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__HXbzp","noInteraction":"EventWrapper_noInteraction__QZyJF"};